module.exports = __webpack_public_path__ + "assets/img/logos/markets/app-store.png";